var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\u30EC\\u30A4\\u30E4\\u30FC_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 254.72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#545454;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_\\u30EC\\u30A4\\u30E4\\u30FC_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M123.72.07C59.13,2.18,4.78,54.42.32,118.89c-4.72,68.21,44.06,125.85,108.56,135.54v-92.51h-20.66c-9.29,0-16.82-7.53-16.82-16.82h0c0-9.29,7.53-16.82,16.82-16.82h20.65v-22.39c0-37.07,18.06-53.34,48.87-53.34,4.57,0,8.47.1,11.79.27,8.14.4,14.45,7.18,14.45,15.33h0c0,8.49-6.87,15.36-15.36,15.36h-5.66c-13.08,0-17.65,12.4-17.65,26.38v18.39h23.94c7.56,0,13.35,6.75,12.2,14.22l-1.38,8.97c-.93,6.02-6.11,10.46-12.2,10.46h-22.55v92.76c62.5-8.49,110.7-61.91,110.7-126.71C256,55.89,196.36-2.29,123.72.07Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFacebook);
export default __webpack_public_path__ + "static/media/icon_facebook.999d874e74a2942eb02f5fa66fa1756c.svg";
export { ForwardRef as ReactComponent };